/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import { LocalDate } from '@js-joda/core';
import { Group } from 'konva/lib/Group';
import { Rect } from 'konva/lib/shapes/Rect';

// ours
import { TLElement } from './TLElement';
import TLBarColumn from './TLBarColumn';
import ProjectJaeger from '../ProjectJaeger';
import UnitService from '../../../services/unit.service';
import { JaegerEvent } from '../data/JaegerEvent.enum';
import TimelineService from '../services/timeline.service.singleton';
import BarFactory from '../factories/bar.factory.singleton';

export enum TLBarType {
    TOP,
    BOTTOM
}

export default class TLBar extends TLElement {
    public parent: TLBarColumn;
    public barType: TLBarType;
    public barGroup: Group;
    public emptyRect: Rect;
    public barRect: Rect;
    public xPosition: number;
    public yPosition: number;
    public type: string;
    public fill: string;
    public maxHeight: number;
    public height: number;
    public width: number;
    public url: string;
    public value: number;
    public projectJaeger: ProjectJaeger;
    public key: string;
    public readonly timelineService: TimelineService;
    private readonly barFactory: BarFactory;

    constructor(parent: TLBarColumn, barType: TLBarType) {
        super();
        this.timelineService = TimelineService.getInstance();
        this.barFactory = BarFactory.getInstance();
        this.barFactory.setParams(this, this.xPosition, this.yPosition);
        this.barFactory.configureBar(this, parent, barType);
        // testing and automation bindings
        this.key = `${parent.index}-${this.type}`;
        (window as any)[`${this.key}-click`] = this.barFactory.onClick.bind(this, this);
        (window as any)[`${this.key}-enter`] = this.barFactory.onMouseEnter.bind(this, this);
        (window as any)[`${this.key}-leave`] = this.barFactory.onMouseExit.bind(this, this);
    }

    private removeListeners(): void {
        this.barGroup.listening(false);
        this.barGroup.off(JaegerEvent.CLICK);
        this.barGroup.off(JaegerEvent.MOUSE_ENTER);
        this.barGroup.off(JaegerEvent.MOUSE_LEAVE);
    }

    public hide(): void {
        this.barGroup.hide();
        this.barGroup.listening(true);
    }

    public show(): void {
        this.barGroup.show();
        this.barGroup.listening(true);
    }

    public create(): void {
        this.barFactory.build(this);
    }

    public destroy(): void {
        if (!this.barGroup) return;
        this.removeListeners();

        // destroy all the pieces
        this.emptyRect.destroy();
        this.barRect.destroy();
        this.barGroup.destroyChildren();
        this.barGroup.destroy();

        // forget the pieces
        this.emptyRect = null;
        this.barRect = null;
        this.barGroup = null;
    }

    public remove(): void {}

    public updateX(): void {
        const bar: Group = this.barGroup;
        const width: number = this.parent.parent.barWidth;
        const date: LocalDate = bar.attrs.date;
        const newX = UnitService.getJaegerX(this.projectJaeger.props.context, this.projectJaeger.props.user, date);
        bar.x(newX);
        const oldWidth = bar.width();
        bar.width(width);
        bar.children.forEach((child) => {
            if (child.width() === oldWidth) child.width(width);
        });
    }

    public updateY(): void {}
}
